import React from 'react';
import { APP_COLORS as C, APP_FONT as F } from '../tokens';
import { CREATE_ACTIONS } from '../constants';
import type { CreateAction } from '../types';

type Props = {
  actions?: ReadonlyArray<CreateAction>;
  onActionClick?: (action: CreateAction) => void;
  onShowAll?: () => void;
};

export default function CreateActions({
  actions = CREATE_ACTIONS,
  onActionClick,
  onShowAll,
}: Props) {
  const [hovered, setHovered] = React.useState<string | null>(null);

  return (
    <div style={{
      display: 'flex',
      gap: 10,
      alignItems: 'center',
      flexWrap: 'wrap',
      marginBottom: 28,
      fontFamily: F.family,
    }}>
      <span style={{
        fontSize: 11,
        fontWeight: 700,
        color: C.sub,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        marginRight: 4,
      }}>
        Create actions
      </span>

      {actions.map((a) => {
        const isHover = hovered === a.id;
        return (
          <button
            key={a.id}
            onMouseEnter={() => setHovered(a.id)}
            onMouseLeave={() => setHovered(null)}
            onClick={() => onActionClick?.(a)}
            style={{
              padding: '8px 15px',
              background: isHover ? C.pillHover : '#fff',
              border: '1px solid ' + C.line,
              borderRadius: 999,
              fontSize: 13,
              fontWeight: 600,
              color: C.ink,
              cursor: 'pointer',
              fontFamily: F.family,
            }}
          >
            {a.label}
          </button>
        );
      })}

      <span
        onClick={onShowAll}
        style={{
          fontSize: 13,
          fontWeight: 700,
          color: C.tealInk,
          padding: '8px 10px',
          cursor: 'pointer',
          marginLeft: 2,
        }}
      >
        Show all
      </span>
    </div>
  );
}
